import React, { useState } from 'react';
import { Chip, Menu, Typography, Box, IconButton, Dialog, DialogTitle, DialogContent, Grid, Card } from '@mui/material';
import { useSnackbar } from 'notistack';
import { Icon } from '@iconify/react';
import useAuthUsers from '../../hooks/useAuthUsers';
import { firestore } from '../../contexts/FirebaseContext';
import { fDateN } from '../../utils/formatTime';

export const MenuDetalleButtonButton = ({
  data,
  // setIsShowingDetails,
  setPaqueteDetallesId
}) => {
  const { currentUser } = useAuthUsers();
  const { enqueueSnackbar } = useSnackbar();
  const { tracking, paquetes, remitente, status, created_at, totalAPagar } = data;

  const [openDialog, setOpenDialog] = useState(false);

  // Functions to open and close the Dialog
  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleDetalles = () => {
    setPaqueteDetallesId(data.tracking);
  };

  const onStatusUpdate = async (status) => {
    const updatedDocument = {
      ...data,
      updated_at: new Date(),
      statusUpdatedBy: currentUser.id,
      status
    };
    const newMovimiento = {
      idPaquete: data.id,
      created_at: new Date(),
      userId: currentUser.id,
      status
    };
    await firestore.collection('paquetes_recepcionados_multimarcas').doc(data.id).update(updatedDocument);
    await firestore.collection('movimiento_paqueteria_multimarcas').add(newMovimiento);
    enqueueSnackbar('Documento actualizado', { variant: 'success' });
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const onDelete = async (id: string) => {
  //   // await deleteDocument('movimiento_paqueteria_multimarcas', '1679511740724');
  //   await deleteDocument('paquetes_recepcionados_multimarcas', id);
  //   console.log(`documento con id ${id} borrado`);
  // };

  return (
    <>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size="small"
      >
        <Icon icon="eva:more-vertical-fill" />
      </IconButton>
      {/* <p onClick={() => onDelete(data.tracking!)}>del</p> */}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <Box sx={{ display: 'flex', padding: 1, flexDirection: 'column', gap: 1 }}>
          <Chip label="Ver detalles" onClick={handleClickOpen} variant="outlined" />
          {data.status !== 'ENTREGADO A PAQUETERÍA' && (
            <Typography variant="h6" sx={{ color: '#0043a9' }} textAlign="center">
              Cambiar status
            </Typography>
          )}

          {data.status === 'RECEPCIONADO' && (
            <Chip label="En Transito" color="success" onClick={() => onStatusUpdate('EN-TRANSITO')} />
          )}
          {data.status === 'EN-TRANSITO' && (
            <Chip
              label="Entregado a paquetería"
              color="success"
              onClick={() => onStatusUpdate('ENTREGADO A PAQUETERÍA')}
            />
          )}
        </Box>
      </Menu>
      <Dialog open={openDialog} onClose={handleCloseDialog}>
        <DialogTitle>Shipping Details</DialogTitle>
        <DialogContent>
          {/* Move your existing content inside the DialogContent component */}
          <Grid container sx={{ width: '100%', mt: 2 }}>
            <Card sx={{ padding: 3, margin: 4, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
              <Grid container sx={{ width: '100%', mt: 2 }}>
                <Grid item xs={12} sm={6} sx={{}}>
                  <Typography variant="h5" color="#ff6a00">
                    Fecha de creación:
                  </Typography>
                  <Typography>{created_at ? fDateN(created_at) : '-'}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} sx={{}}>
                  <Typography variant="h5" color="#ff6a00">
                    Identificador
                  </Typography>
                  <Typography>{tracking}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} sx={{}}>
                  <Typography variant="h5" color="#ff6a00">
                    Estatus de envío
                  </Typography>
                  <Typography>{status}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} sx={{}}>
                  <Typography variant="h5" color="#ff6a00">
                    Remitente
                  </Typography>
                  <Typography>{remitente.nombreRemitente}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} sx={{}}>
                  <Typography variant="h5" color="#ff6a00">
                    Teléfono Remitente
                  </Typography>
                  <Typography>{remitente.telefonoRemitente}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} sx={{}}>
                  <Typography variant="h5" color="#ff6a00">
                    Total a pagar
                  </Typography>
                  <Typography>{totalAPagar}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} sx={{}}>
                  <Typography variant="h5" color="#ff6a00">
                    Paqueterías utilizadas
                  </Typography>
                  {paquetes.map((p, i) => (
                    <Box key={i}>
                      <Typography variant="h6" color="#000d66">
                        {p.paqueteria}
                      </Typography>
                      <Typography>N° Tracking: {p.tracking}</Typography>
                    </Box>
                  ))}
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};
